import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { HomeSoundscapeCmsContent } from 'core/services/cms/interfaces'

import { HomeProductSection } from '../home-product/HomeProductSection'

interface SoundscapeSectionProps {
  content: HomeSoundscapeCmsContent
}

export const SoundscapeSection: React.FC<SoundscapeSectionProps> = ({ content }) => {
  const navigate = useNavigate()

  const handleSoundscapeClick = (): void => {
    if (/^(https?:\/\/|mailto:|tel:)/.test(content.buttonUrl)) {
      window.location.assign(content.buttonUrl)
      return
    }

    navigate(content.buttonUrl)
  }

  return (
    <HomeProductSection
      logoUrl={content.logoUrl}
      text={content.text}
      buttonText={content.buttonText}
      onButtonClick={handleSoundscapeClick}
      desktopBackgroundUrl={content.desktopBackgroundUrl}
      mobileBackgroundUrl={content.mobileBackgroundUrl}
      featureCards={content.featureCards.map((card) => ({
        icon: card.iconUrl,
        text: card.text,
      }))}
    />
  )
}
